import { register } from 'larasnap';
import BodyPortal from './BodyPortal';

register(BodyPortal);
